import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentService } from '../../../services/document.service';
import { BaseComponent } from '../../base.component';
var DocSourceItemComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DocSourceItemComponent, _super);
    function DocSourceItemComponent(_vcr, documentService) {
        var _this = _super.call(this, _vcr) || this;
        _this.documentService = documentService;
        return _this;
    }
    Object.defineProperty(DocSourceItemComponent.prototype, "document", {
        get: function () {
            return this._document;
        },
        set: function (value) {
            this._document = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceItemComponent.prototype, "currentFeature", {
        get: function () {
            return this._currentFeature;
        },
        set: function (value) {
            this._currentFeature = JSONConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceItemComponent.prototype, "showHideClass", {
        get: function () {
            if (this.currentDocument) {
                return this.document !== this.currentDocument ? 'hide' : 'show';
            }
            return ''; // if currentDocSource is not populated yet, don't return a class.
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceItemComponent.prototype, "isTypeSupported", {
        get: function () {
            return this.isImage || this.isVideo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceItemComponent.prototype, "isImage", {
        get: function () {
            return this.documentService.isImage(this.document);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceItemComponent.prototype, "isVideo", {
        get: function () {
            return this.documentService.isVideo(this.document);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], DocSourceItemComponent.prototype, "currentFeature", null);
    return DocSourceItemComponent;
}(BaseComponent));
export { DocSourceItemComponent };
